/* eslint-disable no-unused-vars */

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useWindowDimensions from '@hooks/useWindowDimensions';
import SiteCard from '@components/site-card';
import GoogleMap from '@components/google-map';

import style from './style.module.scss';

const MapListing = ({
  siteData,
  allSiteCoordinatesList,
  detailPage = false,
  siteChildrenList = [],
  parentSiteDetailsPage = false
}) => {
  const { width, height } = useWindowDimensions();

  const { showMapView = false, selectedSiteIdForMapView } =
    useSelector((state) => state.siteMap) || {};

  const { picklistsMap = {} } = useSelector((state) => state.picklists);

  const moveListToTop = () => {
    const virtualListModalContainer1 = document.getElementById('site-listing-on-details-page');
    if (virtualListModalContainer1) {
      virtualListModalContainer1.scrollTo(0, 0);
      virtualListModalContainer1.scrollIntoView({ behavior: 'smooth' });
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  };

  const moveSelectedSiteToTopOnMapView = useMemo(() => {
    if (selectedSiteIdForMapView?.siteId) {
      let arr = selectedSiteIdForMapView?.siteId
        ? [
            ...siteData.filter((i) => i.siteId === selectedSiteIdForMapView.siteId),
            ...siteData.filter((i) => i.siteId !== selectedSiteIdForMapView.siteId)
          ]
        : siteData;
      moveListToTop();

      return arr;
    }
    moveListToTop();
    return siteData;
  }, [selectedSiteIdForMapView?.siteId, siteData]);

  return (
    <div className={style.container}>
      <div className={style.mapAndListContainer}>
        {/* Desktop And Tablet Screen */}
        {width > 1025 ? (
          <div className={`${style.list} ${style.isMapView}`} id="site-listing-on-details-page">
            {moveSelectedSiteToTopOnMapView?.map((listItem, index) => {
              return (
                <React.Fragment key={index}>
                  <SiteCard
                    distance={listItem.distance}
                    unit={listItem.unit}
                    siteDetailsCard
                    mapSiteCard
                    chips={false}
                    title={listItem?.area}
                    subtitle={listItem?.name}
                    dataPoints={listItem?.dataPoints || []}
                    allTasksForSite={listItem?.tasks}
                    allDoneTasks={listItem?.allDoneTasks}
                    isOverDue={listItem?.isOverDue}
                    status={picklistsMap[listItem?.status]?.value || listItem?.status}
                    moreInfo={false}
                    equipmentCount={listItem?.equipmentCount}
                    siteId={listItem?.siteId}
                    index={index}
                    to={`/site-details/${listItem?.siteId}`}
                    toDesktopLink={false}
                  />

                  <div style={{ width: '100%', borderTop: '.5px solid rgb(203, 210, 217)' }} />
                </React.Fragment>
              );
            })}
          </div>
        ) : (
          <></>
        )}

        <div className={style.googleMapContainer} id="Google-Map-Container">
          <GoogleMap
            siteCoordinateList={allSiteCoordinatesList}
            detailPage={detailPage}
            siteChildrenList={siteChildrenList}
            parentSiteDetailsPage={parentSiteDetailsPage}
          />
        </div>
      </div>
    </div>
  );
};

export default MapListing;
